
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TrendingUp, Users, Clock, Activity, BarChart3 } from 'lucide-react';
import { KeyMetricsPanel } from '@/components/analytics/MetricsPanel';
import BikeAnalytics from '@/components/analytics/BikeAnalytics';
import CourierAnalytics from '@/components/analytics/CourierAnalytics';
import RentalDurationAnalytics from '@/components/analytics/RentalDurationAnalytics';
import { RevenuePerBikeCard } from '@/components/analytics/usage/RevenuePerBikeCard';
import { SeasonalDemandCard } from '@/components/analytics/usage/SeasonalDemandCard';
import { FleetEfficiencyCard } from '@/components/analytics/usage/FleetEfficiencyCard';
import { MonthlyMetricsPanel } from '@/components/analytics/monthly/MonthlyMetricsPanel';

const AnalyticsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Аналитика</h1>
        <p className="text-muted-foreground">
          Аналитика работы сервиса проката велосипедов ТУК-ТУК PRO
        </p>
      </div>
      
      <KeyMetricsPanel />
      
      <Tabs defaultValue="bikes">
        <TabsList className="grid w-full grid-cols-5">
          <TabsTrigger value="bikes" className="flex items-center gap-2">
            <TrendingUp className="h-4 w-4" />
            Велосипеды
          </TabsTrigger>
          <TabsTrigger value="couriers" className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            Курьеры
          </TabsTrigger>
          <TabsTrigger value="rentals" className="flex items-center gap-2">
            <Clock className="h-4 w-4" />
            Аренды
          </TabsTrigger>
          <TabsTrigger value="usage" className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Использование
          </TabsTrigger>
          <TabsTrigger value="dynamics" className="flex items-center gap-2">
            <BarChart3 className="h-4 w-4" />
            Динамика
          </TabsTrigger>
        </TabsList>

        <TabsContent value="bikes" className="mt-6">
          <BikeAnalytics />
        </TabsContent>
        
        <TabsContent value="couriers" className="mt-6">
          <CourierAnalytics />
        </TabsContent>
        
        <TabsContent value="rentals" className="mt-6">
          <RentalDurationAnalytics />
        </TabsContent>

        <TabsContent value="usage" className="mt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <RevenuePerBikeCard />
            <SeasonalDemandCard />
            <FleetEfficiencyCard />
          </div>
        </TabsContent>

        <TabsContent value="dynamics" className="mt-6">
          <MonthlyMetricsPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default AnalyticsPage;
